import { Tag } from ".";

export class TagType {
    readonly tagTypeId: number;
    readonly tagTypeName: string;
    readonly tags: Tag[];

    private constructor(id: number, description: string) {
        this.tagTypeName = description;
        this.tagTypeId = id;
        this.tags = Tag.asArray().filter(t => t.tagTypeId === id);
    }

    public tagById = (id?: number) => {
        if (id === undefined || id === null) {
            return undefined;
        }

        const result = this.tags.find(t => t.tagId === id);
        if (result) return result;

        throw Error(
            `tag id: ${id} does not belong to tag type ${this.tagTypeName}(${this.tagTypeId})`
        );
    };

    public static Benefits = new TagType(80, "Benefits");
    public static ContactPreference = new TagType(110, "Contact Preference");
    public static NoticeAvailability = new TagType(140, "Notice Availability");

    public static asArray = (): TagType[] => [
        TagType.Benefits,
        TagType.ContactPreference,
        TagType.NoticeAvailability,
    ];

    public static fromId = (id: number) =>
        TagType.asArray().find(t => t.tagTypeId === id);
}
